import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/world.svg'


const _hoisted_1 = { class: "language_switcher d-flex align-items-center" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "custom-select-display",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.selectedLanguage.name) + " ", 1),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "px-1" }, "|", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        src: _imports_0,
        alt: "languages",
        class: "mr-2",
        width: "20",
        height: "20"
      }, null, -1))
    ]),
    (_ctx.isDropdownOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "custom-options",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "custom-option",
              onClick: ($event: any) => (_ctx.selectLanguage(language))
            }, _toDisplayString(language.name), 9, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}